module.exports = __webpack_public_path__ + "img/adaste-logo.f06ece35.svg";